import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  backToSettings: {
    marginBottom: theme.spacing(3),
  },
  leftArrow: {
    marginRight: theme.spacing(1),
  },
}));
